export default __webpack_public_path__ + "static/media/home.11e75de2.png";